export default "__VITE_ASSET__2197edf4__"